<div class="row">
  <div class="col-12">
    <div class="alert alert-info">
      <div class="mb-3">
        <h2>Request for quote confirmation!</h2>
      </div>
      <div>
        <p>
          Your request for quote has been submitted successfully. Your quote reference number is: <strong>{{quoteNumber}}</strong>
        </p>
        <p>
          You will receive an email confirmation shorly with a PDF attachment of your application.
        </p>
      </div>
    </div>
  </div>
</div>
